<template>
  <div 
    :class="{ 'container--full': layout.full }" 
    class="container"
  >
    <span class="full__bg__image" />
    <div class="flex-grid justify-center">
      <div class="content text-center">
        <h1 class="text-secondary l-mb-6">
          Zelfverzekerd op de woningmarkt
        </h1>
        <h2 class="text-secondary l-mb-6">
          Daar helpt iSalu bij!
        </h2>
      <mouse />
      </div>
    </div>
  </div>
</template>

<script>
import mouse from "@/components/ComponentMouse";
import { mapGetters } from "vuex";

export default {
  name: "Welcome",
  components: {
    mouse
  },
  props: {
    layout: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapGetters(["showVideo"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  font-size: 44px;
  font-weight: 300;
  text-transform: uppercase;
  margin-bottom: 64px;
}

.slide-leave-active {
  transition: 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-enter-active {
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;
}
.slide-enter {
  transform: translate(0, 100%);
}
.slide-leave-to {
  transform: translate(0, 100%);
}

.btn {
  margin-top: 50px;
}

@media (max-width: 720px) {
  h2 {
    font-size: 24px;
    margin-bottom: 44px;  
  }
  .btn {
    margin-left: 0;
    margin-top: 12px;
    width: 100%;
  }
}
</style>
